export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const DEV_BASE_URL = process.env.REACT_APP_DEV_BASE_URL;
